import * as tslib_1 from "tslib";
import { StoryAbstract } from '../shared/story-abstract';
var VpgComponent = /** @class */ (function (_super) {
    tslib_1.__extends(VpgComponent, _super);
    function VpgComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VpgComponent.prototype.getTemplateBlockGroups = function (storyData) {
        var _a = this._generateDCLBannerBlockItems(storyData), items = _a.items, itemsWrapped = _a.itemsWrapped;
        var templateBlockGroups = [{
                classes: 'banner',
                anchorName: 'dcl-looker-standard-banner-block-group-1-anchor',
                blocks: [{
                        analyticsTrackSeen: this.createAnalyticsTrackSeen(storyData, 1),
                        classes: 'banner story-block-1 story-block-row ',
                        items: items,
                        itemsWrapped: itemsWrapped
                    }]
            }];
        return templateBlockGroups;
    };
    /*
     * Construct DCL Banner template block items
     * @param {Object} Story data
     * @returns {Array} Generated items
     */
    VpgComponent.prototype._generateDCLBannerBlockItems = function (storyData) {
        var _this = this;
        var links = [];
        var bgRegex = /(^| )background( |$)/;
        if (storyData.modules.length > 0 && storyData.modules[0].descriptions) {
            storyData.modules[0].descriptions.forEach(function (link, index) {
                links.push({
                    'type': 'link',
                    'classes': 'banner-link',
                    'href': link.webLinks.link1.href,
                    'analyticsLinkId': _this.getStoryAnalyticslinkId(storyData, index, link.webLinks.link1.analyticsLinkId),
                    'items': [
                        _this.getIconTemplate({
                            icon: link.webfont.htmlCharacter,
                            title: link.webLinks.link1.title,
                            htmlentity: link.webfont.htmlCharacter
                        }, 'banner-link-icon'),
                        _this.getTextTemplate(link.webLinks.link1.title, false, 'banner-link-text')
                    ]
                });
            });
        }
        var items = [
            this.getImageTemplate(storyData.modules[0].media.dclBannerBackgroundDesktop, 'banner-desktop-bg background hidden-xs hidden-sm visible-md visible-lg', false),
            this.getImageTemplate(storyData.modules[0].media.dclBannerBackgroundMobile, 'banner-mobile-bg background visible-xs visible-sm hidden-md hidden-lg', false),
            this.getImageTemplate(storyData.modules[0].media.shipImage, 'ship-image'),
            this.getTextTemplate(storyData.modules[0].sections.title, false, 'banner-title'),
            this.getTextTemplate(storyData.modules[0].sections.subtitle, false, 'banner-subtitle hidden-xs hidden-sm visible-md visible-lg'),
            this.getTextTemplate(storyData.modules[0].sections.mobileSubtitle, false, 'banner-subtitle visible-xs visible-sm hidden-md hidden-lg'),
            this.getWrapperTemplate(links, 'banner-links-wrapper')
        ];
        var itemsWrapped = {
            background: [
                items[0],
                items[1]
            ],
            foreground: [
                items[2],
                items[3],
                items[4],
                items[5],
                items[6]
            ]
        };
        return { items: items, itemsWrapped: itemsWrapped };
    };
    return VpgComponent;
}(StoryAbstract));
export { VpgComponent };
